import 'bootstrap'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import TrendChart from "vue-trend-chart";

import { library } from '@fortawesome/fontawesome-svg-core'
import { faColumns, faFolder, faUser, faSignOutAlt, faPlus, faPlug, 
  faBullhorn, faSpinner, faBars, faTimes, faCircle, faGlobeAsia, faTrash, faEllipsisV, faLongArrowAltLeft, faPlay, faPen, faClipboard, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faColumns, faFolder, faUser, faSignOutAlt,faPlus, faPlug, 
  faBullhorn, faSpinner, faBars, faTimes, faCircle, faGlobeAsia, faTrash, faEllipsisV, faLongArrowAltLeft, faPlay, faPen, faClipboard, faQuestionCircle);

Vue.use(TrendChart);
Vue.use(require('vue-moment'));
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
